import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import Button from '../../../components/Button'
import { useDispatch, } from 'react-redux'
import { useFormik } from 'formik'
import { Input, } from '../../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import { api } from '../../../App'
import Modal from 'react-responsive-modal'
import { createUsefulSite, getUsefulSitesFile, updateUsefulSite } from '../../../actions/useful_sites'

const validationSchema = Yup.object({
  title: Yup.string().required('обязательное поле').max(100, 'Должно быть не более 100 символов'),
  text: Yup.string().required('обязательное поле').max(255, 'Должно быть не более 255 символов'),
  link: Yup.string().required('обязательное поле').max(255, 'Должно быть не более 255 символов'),
})

export default function ModalComponent({ data, closeModal, }) {
  const dispatch = useDispatch()

  const [image, setImage] = useState(null);

  const addMode = !data.sid

  const handleCreate = async (values) => {
    dispatch(createUsefulSite(values, image))
    closeModal()
  }

  const handleUpdate = async ({ id, ...values }) => {
    dispatch(updateUsefulSite(id, values, image))
    closeModal()
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit
  } = useFormik({
    initialValues: addMode ? {} : data,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const handlePick = () => {
    document.getElementById('filePicker').click()
  }
  const handleChangeFile = (e) => {
    setImage(Object.values(e.target.files)[0])
  }

  const fetchPhoto = async (id) => {
    // const { data } = await api.get(`/xp_useful_sites/${id}/file`, { responseType: 'blob' })
    // setImage(data)
  }

  useEffect(() => {
    if (data && !addMode) {
      fetchPhoto(values.sid)
    }
  }, [data])

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      center
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} style={{ display: "flex", justifyContent: 'space-evenly', flexDirection: 'column' }}>

            <div className={styles.inputsRow}>
              <Input
                label='Название'
                name='title'
                value={values.title}
                error={error('title')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />

            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Описание'
                name='text'
                value={values.text}
                error={error('text')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Ссылка'
                name='link'
                value={values.link}
                error={error('link')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />
            </div>

            <div className={styles.buttons_wrap}>
              <div className={styles.buttons}>
                <>
                  <Button onClick={handlePick}>{image ? 'Изменить фото' : 'Загрузить фото'}</Button>
                  <input
                    className={styles.hidden}
                    type='file'
                    onChange={(e) => handleChangeFile(e)}
                    accept="image/*"
                    id='filePicker'
                  />
                </>

              </div>
            </div>
            <br />
            {image !== null && !image.hasOwnProperty('picture') &&
              <img
                src={URL.createObjectURL(image)}
                alt="0_o"
                height={350}
                width={450}
              />
            }
          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal>
  )
}
